// App / system integrations shown in the "Systems & Applications" step.
// Extracted verbatim from the deployed build — data matches production 1:1.

export interface AppIntegration {
  id: string;
  color: string;
  bgColor: string;
  logo: string;
  nameAr: string;
  nameEn: string;
  catAr: string;
  catEn: string;
  descAr: string;
  descEn: string;
  usersAr: string[];
  usersEn: string[];
  accessAr: string;
  accessEn: string;
  url: string;
  hasApp: boolean;
  appName?: string;
  ios?: string;
  android?: string;
  paths: string[];
  icon: string;
}

export const apps: AppIntegration[] = [
  {
    id: "netsuite",
    color: "#1977d4",
    bgColor: "rgba(25,119,212,.15)",
    logo: "https://logo.clearbit.com/netsuite.com",
    nameAr: "نظام تخطيط موارد المؤسسة",
    nameEn: "Enterprise Resource Planning (ERP)",
    catAr: "المالية والمشتريات",
    catEn: "Finance & Procurement",
    descAr: "نظام تخطيط موارد المؤسسة (ERP) الرئيسي في كادن. يُمكّنك من رفع طلبات الشراء، ومتابعة الفواتير والمدفوعات، والاطلاع على التقارير المالية.",
    descEn: "Kaden's core ERP system. Submit purchase requests, track invoices and payments, and access financial reports.",
    usersAr: ["جميع موظفي كادن", "قسم المشتريات", "الإدارة المالية"],
    usersEn: ["All Kaden Employees", "Procurement", "Finance"],
    accessAr: "الوصول من بوابة Kaden Gate بنقرة واحدة (SSO)، أو عبر الرابط أدناه بحسابك في Microsoft.",
    accessEn: "One-click access from Kaden Gate (SSO), or via the link below with your Microsoft account.",
    url: "https://account.activedirectory.windowsazure.com/applications/signin/8beb14c4-4df8-4cf4-82c2-e765e6d1e303?tenantId=95565ff3-144c-44e7-b5f4-26ccc44a16b7",
    hasApp: false,
    paths: ["all"],
    icon: "/icons/netsuite.png",
  },
  {
    id: "yardi",
    color: "#00a651",
    bgColor: "rgba(0,166,81,.15)",
    logo: "https://logo.clearbit.com/yardi.com",
    nameAr: "نظام إدارة الأصول",
    nameEn: "Asset Management System",
    catAr: "إدارة الأصول العقارية",
    catEn: "Real Estate Asset Management",
    descAr: "منصة إدارة الأصول والعقارات. تُستخدم لمتابعة الأصول العقارية وإدارة طلبات الصيانة والمرافق في مشاريع كادن.",
    descEn: "Real estate and asset management platform used by the Assets Division to track properties and manage maintenance requests.",
    usersAr: ["إدارة الأصول العقارية"],
    usersEn: ["Assets Division"],
    accessAr: "الوصول عبر بوابة Kaden Gate أو الرابط المباشر ببيانات كادن الخاصة.",
    accessEn: "Access via Kaden Gate or the direct link using your Kaden-specific credentials.",
    url: "https://086075kaden.yardione.com/yAuth2/identity/ExternalAuth/ExternalLogin?provider=086075kaden_&returnUrl=",
    hasApp: false,
    paths: ["assets-management", "project-management", "finance", "commercial"],
    icon: "/icons/yardi.png",
  },
  {
    id: "bevatel-cc",
    color: "#e65c00",
    bgColor: "rgba(230,92,0,.15)",
    logo: "https://logo.clearbit.com/bevatel.com",
    nameAr: "مركز الاتصال",
    nameEn: "Call Center",
    catAr: "خدمة العملاء",
    catEn: "Customer Service",
    descAr: "منصة مركز الاتصال. تُستخدم لاستقبال المكالمات الواردة ومتابعة شكاوى واستفسارات العملاء.",
    descEn: "The integrated call center platform for receiving calls, handling complaints and customer inquiries.",
    usersAr: ["قسم خدمة العملاء، القطاع التجاري"],
    usersEn: ["Customer Service, Commercial Sector"],
    accessAr: "تسجيل الدخول عبر الرابط أدناه ببيانات خدمة العملاء.",
    accessEn: "Sign in via the link below using your customer service credentials.",
    url: "https://app.bevatel.com/auth/login",
    hasApp: true,
    appName: "Call Center",
    ios: "https://apps.apple.com/sa/app/bevatel-call-center/id6737223317",
    android: "https://play.google.com/store/apps/details?id=com.bevatel.call_center",
    paths: ["commercial"],
    icon: "/icons/bevatel_cc.png",
  },
  {
    id: "bevatel-chat",
    color: "#7c3aed",
    bgColor: "rgba(124,58,237,.15)",
    logo: "https://logo.clearbit.com/bevatel.com",
    nameAr: "نظام الويب شات",
    nameEn: "Web Chat",
    catAr: "خدمة العملاء الرقمية",
    catEn: "Digital Customer Service",
    descAr: "منصة إدارة المحادثات الرقمية. تُستخدم لاستقبال رسائل العملاء عبر القنوات الرقمية والرد على استفساراتهم.",
    descEn: "Web chat management platform for receiving and responding to customer messages through digital channels.",
    usersAr: ["قسم خدمة العملاء، القطاع التجاري"],
    usersEn: ["Customer Service, Commercial Sector"],
    accessAr: "تسجيل الدخول عبر الرابط أدناه ببيانات خدمة العملاء.",
    accessEn: "Sign in via the link below using your customer service credentials.",
    url: "https://chat.bevatel.com/app/login",
    hasApp: true,
    appName: "Web Chat",
    ios: "https://apps.apple.com/sa/app/bevatel-business-chat/id1658286397",
    android: "https://play.google.com/store/search?q=chat%20business%20bevatel&c=apps",
    paths: ["commercial"],
    icon: "/icons/bevatel_chat.png",
  },
  {
    id: "menaitech",
    color: "#0891b2",
    bgColor: "rgba(8,145,178,.15)",
    logo: "https://logo.clearbit.com/menaitech.com",
    nameAr: "نظام الموارد البشرية",
    nameEn: "HR Management System (HRMS)",
    catAr: "الموارد البشرية",
    catEn: "Human Resources",
    descAr: "نظام إدارة الموارد البشرية الشامل. بصمة الحضور والانصراف، طلبات الإجازات، مسيرة الرواتب، وخدمات الموظف الذاتية.",
    descEn: "Comprehensive HR system. Attendance tracking, leave requests, payslips, and employee self-service features.",
    usersAr: ["جميع موظفي كادن"],
    usersEn: ["All Kaden Employees"],
    accessAr: "يمكنك تسجيل الدخول ببيانات إيميل العمل مباشرة (الدخول الموحد)، متاح عبر المتصفح أو تطبيق الموارد البشرية على الجوال.",
    accessEn: "Sign in directly with your work email credentials (Single Sign-On), available via browser or the mobile HR app.",
    url: "https://www.menalite.com/menaitech/application/HRMS/mename/index.php?c=Kaden",
    hasApp: true,
    appName: "HR App",
    ios: "https://apps.apple.com/sa/app/mename-plus/id1605759540",
    android: "https://play.google.com/store/search?q=mename-plus%C2%AE&c=apps",
    paths: ["all"],
    icon: "/icons/menaitech.png",
  },
  {
    id: "servicedesk",
    color: "#e5173f",
    bgColor: "rgba(229,23,63,.15)",
    logo: "https://logo.clearbit.com/manageengine.com",
    nameAr: "IT ServiceDesk",
    nameEn: "IT ServiceDesk",
    catAr: "تقنية المعلومات",
    catEn: "Information Technology",
    descAr: "منصة إدارة خدمات تقنية المعلومات والدعم الفني. ارفع طلبات الأجهزة والبرامج، افتح تذاكر للمشاكل التقنية، وتابع عهدتك من الأصول.",
    descEn: "Kaden's ITSM platform. Submit hardware/software requests, open trouble tickets, and track your IT assets.",
    usersAr: ["جميع موظفي كادن"],
    usersEn: ["All Kaden Employees"],
    accessAr: "متاح عبر المتصفح أو تطبيق ServiceDesk Plus Cloud على الجوال.",
    accessEn: "Available via browser or the ServiceDesk Plus Cloud mobile app.",
    url: "https://it.kaden-sa.com/",
    hasApp: true,
    appName: "ServiceDesk Plus Cloud",
    ios: "https://apps.apple.com/sa/app/servicedesk-plus-cloud/id496792710",
    android: "https://play.google.com/store/apps/details?id=com.manageengine.sdp.ondemand",
    paths: ["all"],
    icon: "/icons/servicedesk.png",
  },
  {
    id: "acms",
    color: "#d97706",
    bgColor: "rgba(217,119,6,.15)",
    logo: "https://logo.clearbit.com/roshn.sa",
    nameAr: "نظام إدارة الوصول ACMS",
    nameEn: "ACMS, Access Control",
    catAr: "إدارة الوصول، روشن أعمال",
    catEn: "Access Management, Roshn Front",
    descAr: "نظام إدارة الوصول في مجمع روشن أعمال. أنشئ طلبات زيارة للاجتماعات والزوار للحصول على تصريح دخول للمجمع.",
    descEn: "Access control system for Roshn Front Business. Create visit requests for meetings and visitors to obtain entry permits.",
    usersAr: ["جميع موظفي كادن في روشن أعمال"],
    usersEn: ["All Kaden Employees at Roshn Front Business"],
    accessAr: "متاح عبر المتصفح عبر الرابط أدناه، أو حمّل تطبيق RFB Smart.",
    accessEn: "Available via browser at the link below, or download the RFB Smart app.",
    url: "https://smartoffice.roshn-front-business.com/employee/portal",
    hasApp: true,
    appName: "RFB Smart",
    ios: "https://apps.apple.com/us/app/rfb-smart/id6752638489",
    android: "https://play.google.com/store/apps/details?id=com.sensetime.jv.roshn.office",
    paths: ["all"],
    icon: "/icons/acms.png",
  },
  {
    id: "trio365",
    color: "#2563eb",
    bgColor: "rgba(37,99,235,.15)",
    logo: "https://logo.clearbit.com/trio365.com",
    nameAr: "نظام إدارة المشاريع",
    nameEn: "Project Management System",
    catAr: "إدارة المشاريع",
    catEn: "Project Management",
    descAr: "منصة إدارة المشاريع والمهام. تُستخدم لإدارة المشاريع وتتبع مراحل التنفيذ وتوزيع المهام بين أعضاء الفريق.",
    descEn: "Project management platform used by the Development team to manage projects and track progress.",
    usersAr: ["قسم التطوير", "إدارة المشاريع"],
    usersEn: ["Development Team", "Project Management"],
    accessAr: "تسجيل الدخول عبر الرابط أدناه ببيانات حسابك.",
    accessEn: "Sign in via the link below using your account credentials.",
    url: "https://ksa.trio365.com/#/login",
    hasApp: false,
    paths: ["finance", "project-management", "assets-management", "commercial"],
    icon: "/icons/trio365.png",
  },
  {
    id: "diwan",
    color: "#7e22ce",
    bgColor: "rgba(126,34,206,.15)",
    logo: "https://logo.clearbit.com/trio365.com",
    nameAr: "ديوان، المراسلات",
    nameEn: "Diwan, Correspondence",
    catAr: "المراسلات الرسمية",
    catEn: "Official Correspondence",
    descAr: "منصة إدارة المراسلات والاتصالات الرسمية الصادرة والواردة. أرشفة وتتبع المراسلات بين الأقسام والجهات الخارجية.",
    descEn: "Official correspondence management for inbound and outbound communications between departments and external parties.",
    usersAr: ["جميع الأقسام"],
    usersEn: ["All Departments"],
    accessAr: "ديوان يعمل على نفس منصة نظام إدارة المشاريع. تسجيل الدخول عبر الرابط أدناه.",
    accessEn: "Diwan runs on the same platform as the Project Management System. Sign in via the link below.",
    url: "https://ksa.trio365.com/#/login",
    hasApp: false,
    paths: ["all"],
    icon: "/icons/diwan.png",
  },
  {
    id: "crm",
    color: "#c9302f",
    bgColor: "rgba(201,48,47,.15)",
    logo: "https://logo.clearbit.com/kaden-sa.com",
    nameAr: "نظام إدارة علاقات العملاء (CRM)",
    nameEn: "Customer Relationship Management (CRM)",
    catAr: "المبيعات والتسويق",
    catEn: "Sales & Marketing",
    descAr: "منصة إدارة علاقات العملاء الخاصة بكادن. تُستخدم لمتابعة العملاء المحتملين والفرص البيعية، إدارة الحملات التسويقية، وتوثيق التواصل مع العملاء عبر رحلتهم الكاملة معنا.",
    descEn: "Kaden's customer relationship management platform. Used to track leads and sales opportunities, manage marketing campaigns, and log customer interactions across their full journey with us.",
    usersAr: ["القطاع التجاري والتأجير", "التسويق"],
    usersEn: ["Commercial & Leasing", "Marketing"],
    accessAr: "تسجيل الدخول عبر الرابط أدناه ببيانات حسابك، أو حمّل تطبيق الجوال للوصول أثناء التنقل.",
    accessEn: "Sign in via the link below using your account credentials, or download the mobile app for access on the go.",
    url: "http://crm.kaden-sa.com/",
    hasApp: true,
    appName: "CRM",
    ios: "https://apps.apple.com/us/app/zoho-crm-sales-marketing/id444908810",
    android: "https://play.google.com/store/apps/details?id=com.zoho.crm&hl=en-US",
    paths: ["commercial"],
    icon: "/icons/crm.webp",
  },
];
